export default "__VITE_ASSET__0744d5e2__"